import { Link } from "react-router-dom";
import { rupiah, tanggal } from "@/lib/api";
import { CalendarDays, Plane, Users } from "lucide-react";

const PLACEHOLDER = "https://images.unsplash.com/photo-1693590614566-1d3ea9ef32f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxtZWNjYSUyMG1lZGluYSUyMG1vc3F1ZSUyMGthYWJhJTIwaXNsYW1pYyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODcxMzYwMzd8MA&ixlib=rb-4.1.0&q=85";

export const PackageCard = ({ p, idx = 0 }) => {
  const price = p.promo_price > 0 ? p.promo_price : p.base_price;
  return (
    <article data-testid={`package-card-${p.slug}`}
      className="card-hover reveal overflow-hidden rounded-2xl border border-[#E5DEC9] bg-white"
      style={{ animationDelay: `${idx * 70}ms` }}>
      <div className="relative aspect-[16/10] overflow-hidden sm:aspect-[3/2]">
        <img src={p.hero_image || PLACEHOLDER} alt={p.name} className="h-full w-full object-cover object-center" loading="lazy" />
        <span className="absolute left-4 top-4 rounded-full bg-[#0A0A0A]/85 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-[#D4AF37]">
          {p.category_name}
        </span>
        {p.promo_price > 0 && (
          <span className="btn-gold absolute right-4 top-4 rounded-full px-3 py-1 text-[10px] font-extrabold uppercase">Promo</span>
        )}
      </div>
      <div className="p-6">
        <h3 className="font-display text-xl font-semibold text-[#121212]">{p.name}</h3>
        <p className="mt-2 line-clamp-2 text-sm text-[#4A4844]">{p.short_description}</p>
        <div className="mt-4 flex flex-wrap gap-4 text-xs text-[#8A867C]">
          <span className="flex items-center gap-1"><CalendarDays size={13} /> {p.duration_days} hari</span>
          <span className="flex items-center gap-1"><Plane size={13} /> {p.airline || "-"}</span>
          <span className="flex items-center gap-1"><Users size={13} /> kuota {p.quota}</span>
        </div>
        {p.departures?.length > 0 && (
          <p className="mt-3 text-xs text-[#8A867C]">Keberangkatan terdekat: {tanggal(p.departures[0].depart_date)}</p>
        )}
        <div className="mt-5 flex items-end justify-between border-t border-[#F4EFE6] pt-4">
          <div>
            {p.promo_price > 0 && (
              <div className="text-xs text-[#8A867C] line-through">{rupiah(p.base_price)}</div>
            )}
            <div className="text-xl font-extrabold text-[#141414]">{rupiah(price)}</div>
          </div>
          <Link to={`/paket-detail/${p.slug}`} data-testid={`package-detail-link-${p.slug}`}
            className="rounded-xl border border-[#141414] px-4 py-2 text-sm font-semibold text-[#141414] transition-colors hover:bg-[#141414] hover:text-white">
            Detail
          </Link>
        </div>
      </div>
    </article>
  );
};

export const SectionTitle = ({ title, subtitle, center }) => (
  <div className={center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
    <h2 className="font-display text-3xl font-semibold text-[#141414] lg:text-4xl">{title}</h2>
    {subtitle && <p className="mt-4 text-base text-[#4A4844]">{subtitle}</p>}
  </div>
);

export const Loading = ({ label = "Memuat data..." }) => (
  <div data-testid="loading-state" className="flex items-center justify-center py-24 text-sm text-[#8A867C]">
    <span className="mr-3 h-4 w-4 animate-spin rounded-full border-2 border-[#C5A028] border-t-transparent" />
    {label}
  </div>
);

export const Empty = ({ label }) => (
  <div data-testid="empty-state" className="rounded-2xl border border-dashed border-[#E5DEC9] bg-white py-16 text-center text-sm text-[#8A867C]">
    {label}
  </div>
);
